<template>
  <div>
<!--    <h1>{{ page.title }}</h1>-->
<!--    <div v-html="htmlContent"></div>-->
<!--    <button @click="editPage">Edit</button>-->
    <WikiEditor v-if="editing"   @save="savePage"/>
  </div>
</template>

<script>
import marked from 'marked';
import WikiEditor from "@/WikiEditor.vue";

export default {
  components: {WikiEditor},
  data() {
    return {
      editing: false,
      content: null,
      title: null,
    };
  },
  computed: {
    htmlContent() {
      return marked(this.content);
    }
  },
  created() {
    // const jsonString = readFileSync("@/data/wiki.json");
    // console.log(JSON.parse(jsonString));
  },
  methods: {
    editPage() {
      this.editing = true;
    },
    savePage(updatedPage) {
      this.$emit('save', updatedPage);
      this.editing = false;
    }
  }
};
</script>
